export const ReleaseVersion = '2.5.6';
export const SessionStorageWebAPIKey = 'webAPIToken';
export const RecaptchaKey = '6LcJBb8qAAAAAAzdeGfLmPA31xNPlNcBHt0tto4X';
export const CASP_HOMEPAGE_URL = 'http://www.almondstewardship.org/';
export const DONATE_URL = 'https://give.ucanr.edu/forms/MontereyUCCE-CropManage';
export const DISCORD_URL = 'https://discord.gg/ZcCGvZuzNv';
export const CASPNotNowCookieName = 'CASPNotNow';
export const GlobalNotificationExists = false;

export const VersionUpgradeCookieName = 'showVersionUpdate';
export const enum loginTypes {
	WORKSHOP = 1
}

export const PREVIOUS_CROP_NO_RESIDUE_ID = 14; // Id associated with the "no residue" option
export const DEFAULT_MINERALIZATION_RATE = 2;
